import React, { useEffect, useState } from "react";

import styles from "./CourseList.module.css";
import axios from "axios";

const CourseList = () => {
  const [courses, setCourses] = useState([]);
  const [providerFilter, setProviderFilter] = useState("All");

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_BACKEND_URL}/professional/real-estate-courses`
        );

        setCourses(response.data);
      } catch (error) {
        console.error("Failed to fetch courses:", error);
      }
    };

    fetchCourses();
  }, []);

  const filteredCourses =
    providerFilter === "All"
      ? courses
      : courses.filter((course) => course.provider === providerFilter);

  const providers = ["All", ...new Set(courses.map((c) => c.provider))];

  return (
    <>
      <section className={styles.courseList}>
        <h1 className={styles.heading}>
          Explore Real Estate Learning Resources
        </h1>

        <div className={styles.tabs}>
          {providers.map((provider) => (
            <button
              key={provider}
              className={`${styles.tab} ${
                provider === providerFilter ? styles.activeTab : ""
              }`}
              onClick={() => setProviderFilter(provider)}
            >
              {provider}
            </button>
          ))}
        </div>

        <div className={styles.courseContainer}>
          {filteredCourses.map((course) => (
            <a
              key={course.id}
              href={course.url}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.courseItem}
            >
              <div className={styles.courseContent}>
                <h2 className={styles.courseTitle}>{course.title}</h2>
                <p className={styles.courseProvider}>{course.provider}</p>
              </div>
            </a>
          ))}
        </div>
      </section>
    </>
  );
};

export default CourseList;
